import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

function ProtectedRoute({ children, requiredUserType }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Laden...</span>
                </div>
            </div>
        );
    }

    if (!user) {
        // Not logged in, redirect to login page
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (requiredUserType && user.userType !== requiredUserType) {
        // Wrong user type
        if (user.userType === 'admin') {
            return <Navigate to="/admin" replace />;
        } else {
            return <Navigate to="/member" replace />;
        }
    }

    // Admin mit erzwungener Passwort-Aenderung: nur die Aenderungs-Seite zulassen
    if (user.userType === 'admin'
        && user.must_change_password
        && location.pathname !== '/admin/passwort-aendern') {
        return <Navigate to="/admin/passwort-aendern" replace />;
    }

    return children;
}

export default ProtectedRoute;
